<template>
  <div>
    <loading
      :active.sync="paymentLoading"
      :can-cancel="false"
      :is-full-page="false"
    ></loading>
    <h3>{{ $t('payment') }}<br><small v-if="card">{{ $t('followingCard') }}</small><small v-else>{{ $t('enterCardInfo') }}</small></h3>

    <div v-if="card">
      <!-- <p>{{ $t('followingCard') }}</p> -->
      <div class="payment-card">
        <div class="card-info">
          <span class="brand">{{ card.brand }}</span>
          <span>xxxx xxxx xxxx {{ card.last4 }}</span>
          <span>{{ `0${ card.exp_month }`.slice(-2) }}/{{ card.exp_year }}</span>
        </div>
        <button
          class="btn"
          type="button"
          @click="clearCard"
        >{{ $t('changeCard') }}</button>
      </div>
    </div>
    <div v-else>
      <!-- <p>{{ $t('enterCardInfo') }}</p> -->
      <div class="form-row">
        <div
          id="card-element"
        ></div>
        <div
          id="card-errors"
          role="alert"></div>
      </div>
      <div class="cards">
        <div>
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="50"
              height="50"
              viewBox="0 0 48 48"
              style="fill:#000000;">
              <g>
                <path
                  style=" fill:#3F51B5;"
                  d="M 45 35 C 45 37.210938 43.210938 39 41 39 L 7 39 C 4.789063 39 3 37.210938 3 35 L 3 13 C 3 10.789063 4.789063 9 7 9 L 41 9 C 43.210938 9 45 10.789063 45 13 Z "/>
                <path
                  style=" fill:#FFC107;"
                  d="M 40 24 C 40 29.523438 35.523438 34 30 34 C 24.476563 34 20 29.523438 20 24 C 20 18.476563 24.476563 14 30 14 C 35.523438 14 40 18.476563 40 24 Z "/>
                <path
                  style=" fill:#FF3D00;"
                  d="M 22.015625 30 C 21.550781 29.382813 21.152344 28.714844 20.839844 28 L 26.164063 28 C 26.441406 27.363281 26.660156 26.695313 26.800781 26 L 20.203125 26 C 20.070313 25.355469 20 24.6875 20 24 L 27 24 C 27 23.3125 26.929688 22.644531 26.800781 22 L 20.199219 22 C 20.34375 21.304688 20.558594 20.636719 20.839844 20 L 26.164063 20 C 25.851563 19.285156 25.453125 18.617188 24.988281 18 L 22.015625 18 C 22.449219 17.421875 22.945313 16.878906 23.496094 16.40625 C 21.746094 14.910156 19.480469 14 17 14 C 11.476563 14 7 18.476563 7 24 C 7 29.523438 11.476563 34 17 34 C 20.269531 34 23.160156 32.425781 24.984375 30 Z "/>
              </g>
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="50"
              height="50"
              viewBox="0 0 48 48"
              style="fill:#000000;">
              <g>
                <path
                  style="fill:#1565C0;"
                  d="M 45 35 C 45 37.210938 43.210938 39 41 39 L 7 39 C 4.789063 39 3 37.210938 3 35 L 3 13 C 3 10.789063 4.789063 9 7 9 L 41 9 C 43.210938 9 45 10.789063 45 13 Z "/>
                <path
                  style=" fill:#FFFFFF;"
                  d="M 15.1875 19 L 12.558594 26.832031 C 12.558594 26.832031 11.894531 23.519531 11.828125 23.101563 C 10.332031 19.691406 8.125 19.882813 8.125 19.882813 L 10.726563 30 L 10.726563 29.996094 L 13.886719 29.996094 L 18.257813 19 Z "/>
                <path
                  style=" fill:#FFFFFF;"
                  d="M 17.6875 30 L 20.558594 30 L 22.296875 19 L 19.390625 19 Z "/>
                <path
                  style=" fill:#FFFFFF;"
                  d="M 38.007813 19 L 34.988281 19 L 30.277344 30 L 33.128906 30 L 33.71875 28.429688 L 37.3125 28.429688 L 37.617188 30 L 40.230469 30 Z M 34.511719 26.328125 L 36.074219 22.171875 L 36.894531 26.328125 Z "/>
                <path
                  style=" fill:#FFFFFF;"
                  d="M 26.367188 22.207031 C 26.367188 21.601563 26.867188 21.148438 28.296875 21.148438 C 29.222656 21.148438 30.285156 21.824219 30.285156 21.824219 L 30.753906 19.515625 C 30.753906 19.515625 29.394531 19 28.0625 19 C 25.042969 19 23.484375 20.441406 23.484375 22.269531 C 23.484375 25.578125 27.464844 25.125 27.464844 26.820313 C 27.464844 27.113281 27.234375 27.785156 25.574219 27.785156 C 23.914063 27.785156 22.816406 27.175781 22.816406 27.175781 L 22.320313 29.394531 C 22.320313 29.394531 23.386719 30 25.4375 30 C 27.496094 30 30.355469 28.460938 30.355469 26.246094 C 30.355469 23.585938 26.367188 23.394531 26.367188 22.207031 Z "/>
                <path
                  style=" fill:#FFC107;"
                  d="M 12.210938 24.945313 L 11.246094 20.195313 C 11.246094 20.195313 10.808594 19.167969 9.671875 19.167969 C 8.535156 19.167969 5.234375 19.167969 5.234375 19.167969 C 5.234375 19.167969 10.894531 20.839844 12.210938 24.945313 Z "/>
              </g>
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="50"
              height="50"
              viewBox="0 0 48 48"
              style="fill:#000000;">
              <g>
                <path
                  style=" fill:#E1E7EA;"
                  d="M 45 35 C 45 37.199219 43.199219 39 41 39 L 7 39 C 4.800781 39 3 37.199219 3 35 L 3 13 C 3 10.800781 4.800781 9 7 9 L 41 9 C 43.199219 9 45 10.800781 45 13 Z "/>
                <path
                  style=" fill:#FF6D00;"
                  d="M 45 35 C 45 37.199219 43.199219 39 41 39 L 16 39 C 16 39 39.601563 35.199219 45 24 Z M 22 24 C 22 25.699219 23.300781 27 25 27 C 26.699219 27 28 25.699219 28 24 C 28 22.300781 26.699219 21 25 21 C 23.300781 21 22 22.300781 22 24 Z "/>
                <path
                  style=" "
                  d="M 11.199219 21 L 12.300781 21 L 12.300781 27 L 11.199219 27 Z M 17.199219 24 C 17.199219 25.699219 18.5 27 20.199219 27 C 20.699219 27 21.101563 26.898438 21.601563 26.699219 L 21.601563 25.398438 C 21.199219 25.800781 20.800781 26 20.199219 26 C 19.101563 26 18.300781 25.199219 18.300781 24 C 18.300781 22.898438 19.101563 22 20.199219 22 C 20.699219 22 21.101563 22.199219 21.601563 22.601563 L 21.601563 21.300781 C 21.101563 21.101563 20.699219 20.898438 20.199219 20.898438 C 18.5 21 17.199219 22.398438 17.199219 24 Z M 30.601563 24.898438 L 29 21 L 27.800781 21 L 30.300781 27 L 30.898438 27 L 33.398438 21 L 32.199219 21 Z M 33.898438 27 L 37.101563 27 L 37.101563 26 L 35 26 L 35 24.398438 L 37 24.398438 L 37 23.398438 L 35 23.398438 L 35 22 L 37.101563 22 L 37.101563 21 L 33.898438 21 Z M 41.5 22.800781 C 41.5 21.699219 40.800781 21 39.5 21 L 37.800781 21 L 37.800781 27 L 38.898438 27 L 38.898438 24.601563 L 39 24.601563 L 40.601563 27 L 42 27 L 40.199219 24.5 C 41 24.300781 41.5 23.699219 41.5 22.800781 Z M 39.199219 23.800781 L 38.898438 23.800781 L 38.898438 22 L 39.199219 22 C 39.898438 22 40.300781 22.300781 40.300781 22.898438 C 40.300781 23.398438 40 23.800781 39.199219 23.800781 Z M 7.699219 21 L 6 21 L 6 27 L 7.601563 27 C 10.101563 27 10.699219 24.898438 10.699219 24 C 10.800781 22.199219 9.5 21 7.699219 21 Z M 7.398438 26 L 7.101563 26 L 7.101563 22 L 7.5 22 C 9 22 9.601563 23 9.601563 24 C 9.601563 24.398438 9.5 26 7.398438 26 Z M 15.300781 23.300781 C 14.601563 23 14.398438 22.898438 14.398438 22.601563 C 14.398438 22.199219 14.800781 22 15.199219 22 C 15.5 22 15.800781 22.101563 16.101563 22.5 L 16.699219 21.699219 C 16.199219 21.199219 15.699219 21 15 21 C 14 21 13.199219 21.699219 13.199219 22.699219 C 13.199219 23.5 13.601563 23.898438 14.601563 24.300781 C 15.199219 24.5 15.699219 24.699219 15.699219 25.199219 C 15.699219 25.699219 15.300781 26 14.800781 26 C 14.300781 26 13.800781 25.699219 13.601563 25.199219 L 12.898438 25.898438 C 13.398438 26.699219 14 27 14.898438 27 C 16.101563 27 16.898438 26.199219 16.898438 25.101563 C 16.898438 24.199219 16.5 23.800781 15.300781 23.300781 Z "/>
              </g>
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="50"
              height="50"
              viewBox="0 0 48 48"
              style="fill:#000000;">
              <g>
                <path
                  style=" fill:#1976D2;"
                  d="M 45 35 C 45 37.210938 43.210938 39 41 39 L 7 39 C 4.789063 39 3 37.210938 3 35 L 3 13 C 3 10.789063 4.789063 9 7 9 L 41 9 C 43.210938 9 45 10.789063 45 13 Z "/><path
                    style=" fill:#FFFFFF;"
                    d="M 22.253906 20 L 20.140625 24.683594 L 18.039063 20 L 15.34375 20 L 15.34375 26.726563 L 12.339844 20 L 10.066406 20 L 7 26.980469 L 8.816406 26.980469 L 9.484375 25.421875 L 12.917969 25.421875 L 13.601563 26.980469 L 17.066406 26.980469 L 17.066406 21.796875 L 19.363281 26.980469 L 20.925781 26.980469 L 23.277344 21.886719 L 23.277344 26.980469 L 25 26.980469 L 25 20 Z M 10.136719 23.914063 L 11.160156 21.476563 L 12.226563 23.914063 Z "/>
                <path
                  style=" fill:#FFFFFF;"
                  d="M 37.882813 23.414063 L 41 20.019531 L 38.78125 20.019531 L 36.789063 22.183594 L 34.859375 20 L 28 20 L 28 26.980469 L 34.636719 26.980469 L 36.726563 24.671875 L 38.765625 27 L 40.976563 27 Z M 33.726563 25.515625 L 29.71875 25.515625 L 29.71875 24.136719 L 33.554688 24.136719 L 33.554688 22.8125 L 29.71875 22.8125 L 29.71875 21.503906 L 33.949219 21.515625 L 35.644531 23.414063 Z "/>
              </g>
            </svg>
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="40"
                height="40"
                viewBox="0 0 48 48"
                style="fill:#000000;">
                <g>
                  <path
                    style=" fill:#424242;"
                    d="M 24 4 C 18.5 4 14 8.5 14 14 L 14 18 L 18 18 L 18 14 C 18 10.699219 20.699219 8 24 8 C 27.300781 8 30 10.699219 30 14 L 30 18 L 34 18 L 34 14 C 34 8.5 29.5 4 24 4 Z "/>
                  <path
                    style=" fill:#FB8C00;"
                    d="M 36 44 L 12 44 C 9.800781 44 8 42.199219 8 40 L 8 22 C 8 19.800781 9.800781 18 12 18 L 36 18 C 38.199219 18 40 19.800781 40 22 L 40 40 C 40 42.199219 38.199219 44 36 44 Z "/>
                  <path
                    style=" fill:#C76E00;"
                    d="M 27 31 C 27 32.65625 25.65625 34 24 34 C 22.34375 34 21 32.65625 21 31 C 21 29.34375 22.34375 28 24 28 C 25.65625 28 27 29.34375 27 31 Z "/>
                </g>
              </svg>
              {{ $t('safeAndSecure') }}
            </span>
          </div>
          <a
            href="https://stripe.com/ca"
            target="_blank">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="119px"
              height="26px">
              <path
                fill-rule="evenodd"
                opacity="0.502"
                fill="rgb(66, 71, 112)"
                d="M113.000,26.000 L6.000,26.000 C2.686,26.000 0.000,23.314 0.000,20.000 L0.000,6.000 C0.000,2.686 2.686,-0.000 6.000,-0.000 L113.000,-0.000 C116.314,-0.000 119.000,2.686 119.000,6.000 L119.000,20.000 C119.000,23.314 116.314,26.000 113.000,26.000 ZM11.128,8.892 L8.571,8.892 L8.571,16.133 L9.918,16.133 L9.918,13.533 L11.128,13.533 C12.602,13.533 13.654,12.586 13.654,11.218 C13.654,9.850 12.602,8.892 11.128,8.892 ZM17.043,10.745 C15.454,10.745 14.328,11.881 14.328,13.502 C14.328,15.112 15.454,16.259 17.043,16.259 C18.632,16.259 19.748,15.112 19.748,13.502 C19.748,11.881 18.632,10.745 17.043,10.745 ZM26.936,10.871 L25.873,14.449 L24.810,10.871 L23.590,10.871 L22.527,14.449 L21.464,10.871 L20.117,10.871 L21.927,16.133 L23.137,16.133 L24.200,12.555 L25.274,16.133 L26.484,16.133 L28.283,10.871 L26.936,10.871 ZM31.252,10.745 C29.747,10.745 28.653,11.871 28.653,13.460 C28.653,15.101 29.768,16.259 31.357,16.259 C31.946,16.259 32.546,16.122 33.146,15.849 L33.146,14.722 C32.599,15.038 32.062,15.217 31.578,15.217 C30.694,15.217 30.063,14.670 29.978,13.870 L33.546,13.870 C33.567,13.691 33.567,13.523 33.567,13.375 C33.567,11.829 32.630,10.745 31.252,10.745 ZM37.724,10.797 C37.577,10.755 37.430,10.745 37.282,10.745 C36.830,10.745 36.367,10.976 35.988,11.397 L35.988,10.871 L34.641,10.871 L34.641,16.133 L35.988,16.133 L35.988,12.618 C36.335,12.176 36.809,11.934 37.251,11.934 C37.409,11.934 37.577,11.955 37.724,11.997 L37.724,10.797 ZM40.808,10.745 C39.303,10.745 38.209,11.871 38.209,13.460 C38.209,15.101 39.325,16.259 40.914,16.259 C41.503,16.259 42.103,16.122 42.703,15.849 L42.703,14.722 C42.155,15.038 41.619,15.217 41.134,15.217 C40.251,15.217 39.619,14.670 39.535,13.870 L43.102,13.870 C43.123,13.691 43.123,13.523 43.123,13.375 C43.123,11.829 42.187,10.745 40.808,10.745 ZM48.912,8.566 L47.554,8.566 L47.554,11.229 C47.144,10.913 46.681,10.745 46.218,10.745 C44.818,10.745 43.840,11.881 43.840,13.502 C43.840,15.122 44.818,16.259 46.218,16.259 C46.681,16.259 47.144,16.091 47.554,15.764 L47.554,16.133 L48.912,16.133 L48.912,8.566 ZM55.690,10.745 C55.238,10.745 54.775,10.913 54.354,11.229 L54.354,8.566 L53.007,8.566 L53.007,16.133 L54.354,16.133 L54.354,15.764 C54.775,16.091 55.238,16.259 55.690,16.259 C57.100,16.259 58.068,15.122 58.068,13.502 C58.068,11.881 57.100,10.745 55.690,10.745 ZM62.310,10.871 L61.037,14.323 L59.774,10.871 L58.395,10.871 L60.405,15.943 L59.395,18.437 L60.700,18.437 L63.689,10.871 L62.310,10.871 ZM73.109,10.288 C73.972,10.288 75.069,10.552 75.933,11.019 L75.933,8.344 C74.992,7.969 74.052,7.825 73.111,7.825 C70.808,7.825 69.273,9.028 69.273,11.038 C69.273,14.181 73.589,13.671 73.589,15.026 C73.589,15.551 73.133,15.721 72.500,15.721 C71.559,15.721 70.345,15.332 69.392,14.814 L69.392,17.525 C70.448,17.979 71.518,18.169 72.497,18.169 C74.858,18.169 76.485,17.003 76.485,14.959 C76.485,11.573 72.144,12.181 72.144,10.903 C72.144,10.460 72.514,10.288 73.109,10.288 ZM82.180,8.014 L80.024,8.014 L80.022,5.548 L77.250,6.138 L77.237,15.247 C77.237,16.928 78.502,18.169 80.187,18.169 C81.115,18.169 81.801,18.001 82.179,17.793 L82.179,15.482 C81.816,15.627 80.024,16.148 80.024,14.475 L80.024,10.435 L82.180,10.435 L82.180,8.014 ZM88.275,8.015 C87.897,7.879 86.570,7.631 85.905,8.853 L85.727,8.014 L83.272,8.014 L83.272,17.966 L86.110,17.966 L86.110,11.219 C86.781,10.338 87.914,10.508 88.275,10.625 L88.275,8.015 ZM91.999,4.230 L89.149,4.836 L89.149,7.149 L91.999,6.543 L91.999,4.230 ZM91.999,8.014 L89.149,8.014 L89.149,17.966 L91.999,17.966 L91.999,8.014 ZM98.125,7.825 C97.012,7.825 96.293,8.349 95.901,8.715 L95.753,8.014 L93.253,8.014 L93.254,21.268 L96.093,20.664 L96.099,17.451 C96.507,17.750 97.114,18.169 98.108,18.169 C100.139,18.169 101.997,16.535 101.997,12.927 C101.997,9.621 100.119,7.825 98.125,7.825 ZM107.049,7.825 C104.348,7.825 102.704,10.121 102.704,13.013 C102.704,16.437 104.642,18.169 107.408,18.169 C108.765,18.169 109.784,17.861 110.555,17.433 L110.555,15.146 C109.781,15.536 108.893,15.774 107.766,15.774 C106.659,15.774 105.684,15.382 105.557,14.051 L111.116,14.051 C111.129,13.898 111.154,13.303 111.154,13.028 C111.154,10.120 109.746,7.825 107.049,7.825 ZM107.031,10.140 C107.728,10.140 108.468,10.677 108.468,11.955 L105.532,11.955 C105.532,10.676 106.321,10.140 107.031,10.140 ZM97.446,15.661 C96.780,15.661 96.383,15.421 96.107,15.122 L96.090,10.903 C96.386,10.578 96.795,10.340 97.446,10.340 C98.485,10.340 99.200,11.504 99.200,12.989 C99.200,14.518 98.496,15.661 97.446,15.661 ZM55.406,15.101 C55.038,15.101 54.669,14.943 54.354,14.628 L54.354,12.376 C54.669,12.060 55.038,11.902 55.406,11.902 C56.164,11.902 56.690,12.555 56.690,13.502 C56.690,14.449 56.164,15.101 55.406,15.101 ZM46.513,15.101 C45.744,15.101 45.218,14.449 45.218,13.502 C45.218,12.555 45.744,11.902 46.513,11.902 C46.881,11.902 47.249,12.060 47.554,12.376 L47.554,14.628 C47.249,14.943 46.881,15.101 46.513,15.101 ZM40.756,11.786 C41.355,11.786 41.787,12.281 41.829,12.997 L39.535,12.997 C39.598,12.271 40.103,11.786 40.756,11.786 ZM31.199,11.786 C31.799,11.786 32.231,12.281 32.273,12.997 L29.978,12.997 C30.042,12.271 30.547,11.786 31.199,11.786 ZM17.043,15.133 C16.254,15.133 15.707,14.470 15.707,13.502 C15.707,12.534 16.254,11.871 17.043,11.871 C17.822,11.871 18.369,12.534 18.369,13.502 C18.369,14.470 17.822,15.133 17.043,15.133 ZM10.939,12.439 L9.918,12.439 L9.918,9.987 L10.939,9.987 C11.718,9.987 12.265,10.482 12.265,11.218 C12.265,11.944 11.718,12.439 10.939,12.439 Z"/>
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';

const stripe = window.Stripe(process.env.VUE_APP_STRIPE_TOKEN);
const elements = stripe.elements({
  fonts: [
    {
      cssSrc: 'https://use.typekit.net/zjc5siy.css',
    },
  ],
});
const style = {
  base: {
    fontSize: window.innerWidth <= 410 ? '13px' : '17.5px',
    color: '#002e39',
    // fontFamily: 'tondo',
  },
};
const card = elements.create('card', { style });
card.update({ hidePostalCode: true });

window.addEventListener('resize', () => {
  if (window.innerWidth <= 410) {
    card.update({ style: { base: { fontSize: '13px' } } });
  } else {
    card.update({ style: { base: { fontSize: '17.5px' } } });
  }
});

export default {
  name: 'Payment',
  components: {
    Loading,
  },
  props: {
    postalCode: {
      type: String,
      default: () => '',
    },
    token: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      card: null,
      paymentCompleted: false,
      paymentLoading: false,
    };
  },
  mounted() {
    this.mountStripeForm();
  },
  methods: {
    mountStripeForm() {
      this.paymentLoading = true;
      card.mount('#card-element');

      card.addEventListener('ready', () => {
        this.paymentLoading = false;
      });

      card.update({ value: { postalCode: this.postalCode } });

      card.addEventListener('change', (event) => {
        if (event.complete) {
          this.paymentCompleted = true;
        } else {
          this.paymentCompleted = false;
        }

        const displayError = document.getElementById('card-errors');
        if (event.error) {
          displayError.textContent = event.error.message;
        } else {
          displayError.textContent = '';
        }
      });
    },
    clearCard() {
      card.unmount();
      this.card = null;
      this.paymentCompleted = false;
      this.$emit('clearPayment');

      setTimeout(() => {
        this.mountStripeForm();
      }, 100);
    },
    pay() {
      this.paymentLoading = true;
      this.paymentCompleted = false;
      this.$emit('paymentLoading', true);
      this.card = null;
      if (this.token !== '') {
        this.$emit('pay', this.token);
      } else {
        stripe.createToken(card).then((result) => {
          if (result.error) {
            const errorElement = document.getElementById('card-errors');
            errorElement.textContent = result.error.message;
          } else {
            this.card = result.token.card;
            this.$emit('pay', result.token.id);
          }
        });
      }
      this.paymentLoading = false;
      this.$emit('paymentLoading', false);
    },
  },
};
</script>
